import {
  Box,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import { ProcessOfferAttachedEmailDto } from '@/api/generated';
import { themeColors } from '@/config/theme/themeColors.ts';
import { formatDate } from '@/utils/formatDate.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { EmailPreviewDialog } from '@/views/processes/offer/components/emails/EmailPreviewDialog.comp.tsx';

interface Props {
  emails: ProcessOfferAttachedEmailDto[];
}

export const ProcessOfferEmailsTable: React.FC<Props> = ({ emails }) => {
  const { t } = useTranslationWithPrefix('views.process.offer.emails');
  const [previewEmailId, setPreviewEmailId] = useState<string | null>(null);

  if (emails.length === 0) {
    return <Typography sx={{ color: themeColors.greyDark, py: 1 }}>{t('empty')}</Typography>;
  }

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('column.subject')}</TableCell>
            <TableCell>{t('column.from')}</TableCell>
            <TableCell>{t('column.to')}</TableCell>
            <TableCell>{t('column.date')}</TableCell>
            <TableCell>{t('column.status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {emails.map(email => (
            <TableRow
              hover
              key={email.emailId}
              onClick={() => setPreviewEmailId(email.emailId)}
              sx={{ cursor: 'pointer' }}
            >
              <TableCell>{email.subject || t('noSubject')}</TableCell>
              <TableCell>{email.fromAddress}</TableCell>
              <TableCell>
                <Stack spacing={0.25}>
                  {email.toAddresses.map(addr => (
                    <Box component="span" key={addr}>
                      {addr}
                    </Box>
                  ))}
                </Stack>
              </TableCell>
              <TableCell>{formatDate(email.date, { withTime: true })}</TableCell>
              <TableCell>
                <Chip
                  color={email.isDraft ? 'default' : 'success'}
                  label={email.isDraft ? t('status.draft') : t('status.sent')}
                  size="small"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {previewEmailId && (
        <EmailPreviewDialog emailId={previewEmailId} onClose={() => setPreviewEmailId(null)} />
      )}
    </>
  );
};
